import { render, staticRenderFns } from "./ItemListByWorld.vue?vue&type=template&id=4d9df81a&scoped=true&"
import script from "./ItemListByWorld.vue?vue&type=script&lang=js&"
export * from "./ItemListByWorld.vue?vue&type=script&lang=js&"
import style0 from "./ItemListByWorld.vue?vue&type=style&index=0&id=4d9df81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9df81a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDataTable,VTextField})
